module.exports = {
	"LANGUAGE": "Idioma",
	"HDR-obpa_fulltext_score": "Classificação",
	"HDR-obpa_name": "Nome",
	"HDR-obpa_fulltext_summary": "Resumo",
	"QUERY LIMIT REACHED": "Há mais resultados do que os exibidos. Restrinja seus critérios de pesquisa.",
	"NO DOCUMENTS FOUND": "Nenhum documento encontrado.",
	"OPEN IN NEW WINDOW": "Abrir em nova janela",
	"DOWNLOAD NATIVE": "Descarregar em formato nativo",
	"CLOSE": "Fechar",
	"SEARCH TYPE": "Tipo de pesquisa",
	"DOCUMENT TYPE": "Tipo de documento",
	"SEARCH TERM": "Termo de pesquisa",
	"SEARCH": "Pesquisar",
	"RESET": "Redefinir",
	"DATE": "Data",
	"FROM DATE": "Data inicial",
	"TO DATE": "Data final",
	"LOADING": "Carregando...",
	"RETRY": "Tentar novamente",
	"ERROR": "Erro!",
	"ERROR: QUERIES": "Não é possível recuperar a lista de tipos de pesquisa.",
	"ERROR: DOCTYPES": "Não é possível recuperar a lista de tipos de documentos.",
	"ERROR: KEYWORDS": "Não é possível recuperar a lista de campos de pesquisa.",
	"ERROR: DOCUMENTS": "Não é possível executar a pesquisa solicitada.",
	"FORM: INVALID FULLTEXT": "O campo deve ter pelo menos {{chars}} caracteres.",
	"FORM: INVALID DATE SHORT": "Formato: {{format}} .",
	"FORM: REQUIRED KEYWORD": "O campo é necessário.",
	"FORM: INVALID NUMERIC": "O campo deve ser um número de até {{digits}} dígitos.",
	"FORM: INVALID DATE": "O campo deve seguir o formato {{format}} .",
	"FORM: INVALID CURRENCY": "O campo deve ser um valor de moeda válido.",
	"FORM: INVALID FLOAT": "O campo deve ser um número.",
	"FORM: INVALID LENGTH": "O campo deve ter no máximo {{chars}} caracteres.",
	"FORM: ERRORS": "Há erros no formulário.",
	"FORM: noDate": "Um intervalo de datas deve ser especificado.",
	"FORM: noKeyword": "Pelo menos um campo deve ser especificado.",
	"FORM: noDateOrKeyword": "Um intervalo de datas OU pelo menos um campo deve ser especificado.",
	"FORM: noDateAndKeyword": "Um intervalo de datas E pelo menos um campo deve ser especificado."
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/pt.json
// module id = 359
// module chunks = 0